import React, {Component} from 'react';
import DialogBody from "../../containers/common/KpnDialog/DialogBody";
import {Input, Row} from "react-materialize";
import DatePicker from "../../components/datePicker";
import {formatDate} from "../../utils/utils";
import './index.css';
import GeneralDialog from "../../containers/common/GeneralDialog";
import countryCodes, {countries} from "../../constants/countryCodes";

const primaryIDTranslation = new Map([
    ['European identification', 'Europese identificatie'],
    ['Passport', 'Paspoort'],
    ['IND sticker', 'IND-sticker'],
    ['Drivers license', 'Rijbewijs'],
    ['Privileged person identity card', 'Identiteitskaart bevoorrechte persoon'],
    ['Residence permit type I', 'Verblijfsvergunning type I'],
    ['Residence permit type II', 'Verblijfsvergunning type II'],
    ['Residence permit type III', 'Verblijfsvergunning type III'],
    ['Residence permit type IV', 'Verblijfsvergunning type IV'],
    ['Residence card EU/EER', 'Verblijfskaart EU/EER'],
    ['Residence permit Article 50 TEU', 'Verblijfsvergunning Artikel 50 VEU'],
    ['Document permanent residency', 'Document permanente verblijfsvergunning'],
]);

class CustomerOrderDataDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customerData: this.props.customerData
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.customerData !== this.props.customerData) {
            this.setState({customerData: this.props.customerData});
        }
    }

    onChangeBirthDate = (date) => {
        this.handleChangeDate('birthDate', date);
    };

    onChangeContactPersonBirthDate = (date) => {
        this.handleChangeDate('contactPersonBirthDate', date);
    };

    handleChangePrimaryIDValidityDate = (date) => {
        this.handleChangeDate('primaryIDValidityDate', date);
    };

    handleChangeDate = (name, value) => {
        let updatedOrderDetails = this.state.customerData;
        updatedOrderDetails[name] = value.toISOString();

        this.setState({customerData: updatedOrderDetails});
    };

    handleOrderDetailsChange = ({target}) => {
        let {name, value} = target;

        let updatedOrderDetails = this.state.customerData;

        if (value === 'Maak een keuze a.u.b') {
            value = null;
        }

        updatedOrderDetails[name] = value;

        this.setState({customerData: updatedOrderDetails});
    };


    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(this.state.customerData);
    };

    render() {
        const {dialogOpened, onCancel, wizardOptions} = this.props;
        const {customerData} = this.state;

        return (
            <GeneralDialog
                dialogState={dialogOpened}
                modal={false}
                closeHandler={onCancel}
                headerText={'Klantbestelgegevens'}
                onRequestClose={onCancel}
                style={{minHeight: 600}}
                dialogBodyContentRaw={
                    <DialogBody>
                        <form ref={(ref) => (this.globalForm = ref)} onSubmit={this.onSubmit}>
                            <Row>
                                <div className="col s12">
                                    <div className="line tussenkop section-header">bestellen - contracteigenaar</div>
                                </div>
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    ref="nameInitials"
                                    name="nameInitials"
                                    label="Naam initialen*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.nameInitials || ''}
                                    required
                                    className={"validate " + (customerData.nameInitials?.length ? 'valid' : 'invalid')}
                                />
                                <Input
                                    s={6}
                                    type="text"
                                    name="lastName"
                                    ref="lastName"
                                    label="Achternaam*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.lastName || ''}
                                    required
                                    className={"validate " + (customerData.lastName?.length ? 'valid' : 'invalid')}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    name="firstName"
                                    label="Voornaam"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.firstName || ''}
                                />
                                <Input
                                    s={6}
                                    type="text"
                                    name="namePrefix"
                                    label="Voorvoegsel naam"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.namePrefix || ''}
                                />
                            </Row>

                            <Row>
                                <Input
                                    s={6}
                                    type="select"
                                    name="gender"
                                    ref="gender"
                                    required
                                    label="Geslacht"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.gender}
                                    className={"validate " + (customerData.gender?.length ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="payment-method-no-selection">Maak een keuze a.u.b</option>
                                    <option value={'U'} key="contract-owner-gender-unknown">Niet bekendmaken</option>
                                    <option value={'M'} key="contract-owner-gender-male">Mannelijk</option>
                                    <option value={'F'} key="contract-owner-gender-female">Vrouwelijk</option>
                                </Input>
                                <div className="col s6 input-field">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        maxDate={new Date()}
                                        noMinDate={true}
                                        style={{marginBottom: '20px'}}
                                        name="birthDate"
                                        ref="birthDate"
                                        onChange={this.onChangeBirthDate}
                                        onChangeRaw={e => e.preventDefault()}
                                        selected={customerData.birthDate ? Date.parse(customerData.birthDate) : ''}
                                        className={"validate " + (customerData.birthDate?.length ? 'valid' : 'invalid')}
                                    />
                                    <label>Geboortedatum*</label>
                                </div>
                            </Row>

                            <Row>
                                <Input
                                    s={6}
                                    type="select"
                                    name="primaryIdDocument"
                                    ref="primaryIdDocument"
                                    label="Primair ID-document*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.primaryIdDocument}
                                    className={"validate " + (customerData.primaryIdDocument ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="primaryID-no-selection">Maak een keuze a.u.b</option>
                                    {wizardOptions.identificationOptions.map((id) => (
                                        <option value={id} key={id}>{primaryIDTranslation.get(id)}</option>
                                    ))}
                                </Input>
                                <Input
                                    s={6}
                                    type="select"
                                    name="primaryIdNationality"
                                    ref="primaryIdNationality"
                                    label="Primaire ID Nationaliteit*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.primaryIdNationality}
                                    className={"validate " + (customerData.primaryIdNationality?.length ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="primaryID-nationality-no-selection">Maak een keuze a.u.b</option>
                                    {countries.map((country) => (
                                        <option value={countryCodes[country]} key={countryCodes[country]}>{country}</option>
                                    ))}
                                </Input>
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    name="primaryIdNumber"
                                    ref="primaryIdNumber"
                                    label="Primair ID-nummer*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.primaryIdNumber || ''}
                                    className={"validate " + (customerData.primaryIdNumber?.length ? 'valid' : 'invalid')}
                                />
                                <div className="col s6 input-field">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        minDate={new Date()}
                                        style={{marginBottom: '20px'}}
                                        name="primaryIdValidityDate"
                                        ref="primaryIdValidityDate"
                                        onChange={this.handleChangePrimaryIDValidityDate}
                                        onChangeRaw={e => e.preventDefault()}
                                        selected={customerData.primaryIdValidityDate ? Date.parse(customerData.primaryIdValidityDate) : ''}
                                        className={"validate " + (customerData.primaryIdValidityDate?.length ? 'valid' : 'invalid')}
                                    />
                                    <label>Primaire ID Geldigheidsdatum*</label>
                                </div>
                            </Row>

                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    name="bankAccountNumber"
                                    ref="bankAccountNumber"
                                    label="Bankrekeningnummer"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.bankAccountNumber || ''}
                                    className={"validate " + (customerData.bankAccountNumber?.length ? 'valid' : 'invalid')}
                                />
                                <Input
                                    s={6}
                                    type="select"
                                    name="paymentMethod"
                                    ref="paymentMethod"
                                    required
                                    label="Betalingsmiddel"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.paymentMethod}
                                    className={"validate " + (customerData.paymentMethod?.length ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="payment-method-no-selection">Maak een keuze a.u.b</option>
                                    {wizardOptions.paymentMethodOptions.map((paymentMethod) => (
                                        <option value={paymentMethod}
                                                key={paymentMethod}>{paymentMethod === 'Direct Debit' ? 'Automatische Incasso' : paymentMethod}</option>
                                    ))}
                                </Input>
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    type="select"
                                    name="paymentTerm"
                                    ref="paymentTerm"
                                    label="Betalingstermijn"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.paymentTerm}
                                    className={"validate " + (customerData.paymentTerm?.length ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="payment-term-no-selection">Maak een keuze a.u.b</option>
                                    {wizardOptions.paymentTermOptions.map((paymentTerm) => (
                                        <option value={paymentTerm} key={paymentTerm}>{paymentTerm}</option>
                                    ))}
                                </Input>
                                <Input
                                    s={6}
                                    type="select"
                                    name="customerType"
                                    ref="customerType"
                                    label="Klant type"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.customerType}
                                    className={"validate " + (customerData.customerType?.length ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="customer-type-no-selection">Maak een keuze a.u.b</option>
                                    {wizardOptions.customerTypeOptions.map((customerType) => (
                                        <option value={customerType} key={customerType}>{customerType}</option>
                                    ))}
                                </Input>
                            </Row>
                            <Row>
                                <div className="col s12">
                                    <div className="line tussenkop section-header">Bestellen - Contactgegevens</div>
                                </div>
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    ref="contactPersonNameInitials"
                                    name="contactPersonNameInitials"
                                    label="Contactpersoon naam initialen*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonNameInitials || ''}
                                    required
                                    className={"validate " + (customerData.contactPersonNameInitials?.length ? 'valid' : 'invalid')}
                                />
                                <Input
                                    s={6}
                                    type="text"
                                    name="contactPersonLastName"
                                    ref="contactPersonLastName"
                                    label="Contactpersoon achternaam*"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonLastName || ''}
                                    required
                                    className={"validate " + (customerData.contactPersonLastName?.length ? 'valid' : 'invalid')}
                                />
                            </Row>
                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    name="contactPersonFirstName"
                                    label="Contactpersoon voornaam"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonFirstName || ''}
                                />
                                <Input
                                    s={6}
                                    type="text"
                                    name="contactPersonNamePrefix"
                                    label="Contactpersoon Voorvoegsel naam"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonNamePrefix || ''}
                                />
                            </Row>

                            <Row>
                                <Input
                                    s={6}
                                    type="select"
                                    name="contactPersonGender"
                                    ref="contactPersonGender"
                                    required
                                    label="Contactpersoon Geslacht"
                                    style={{marginBottom: '20px'}}
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonGender}
                                    className={"validate " + (customerData.contactPersonGender?.length ? 'valid' : 'invalid')}
                                >
                                    <option value={null} key="payment-method-no-selection">Maak een keuze a.u.b</option>
                                    <option value={'U'} key="contract-owner-gender-unknown">Niet bekendmaken</option>
                                    <option value={'M'} key="contract-owner-gender-male">Mannelijk</option>
                                    <option value={'F'} key="contract-owner-gender-female">Vrouwelijk</option>
                                </Input>
                                <div className="col s6 input-field">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        maxDate={new Date()}
                                        noMinDate={true}
                                        style={{marginBottom: '20px'}}
                                        name="contactPersonBirthDate"
                                        ref="contactPersonBirthDate"
                                        onChange={this.onChangeContactPersonBirthDate}
                                        onChangeRaw={e => e.preventDefault()}
                                        selected={customerData.contactPersonBirthDate ? Date.parse(customerData.contactPersonBirthDate) : ''}
                                        className={"validate " + (customerData.contactPersonBirthDate?.length ? 'valid' : 'invalid')}
                                    />
                                    <label>Contactpersoon geboortedatum*</label>
                                </div>
                            </Row>

                            <Row>
                                <Input
                                    s={6}
                                    type="text"
                                    name="contactPersonEmail"
                                    label="Contactpersoon email"
                                    style={{marginBottom: '20px'}}
                                    pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,9}$"
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonEmail || ''}
                                />
                                <Input
                                    s={6}
                                    type="text"
                                    name="contactPersonPhoneNumber"
                                    label="Contactpersoon telefoonnummer"
                                    style={{marginBottom: '20px'}}
                                    minLength="10"
                                    pattern="^\d+"
                                    onChange={this.handleOrderDetailsChange}
                                    value={customerData.contactPersonPhoneNumber || ''}
                                />
                            </Row>

                            <button
                                className="btn doceri-btn-right ratio-btn-right"
                                type="submit"
                            >
                                Bewerken
                            </button>
                        </form>
                    </DialogBody>
                }
            />
        )
    }
}

export default CustomerOrderDataDialog;
